import React, { FC, useEffect } from 'react';
import {
    Card,
    CardMedia,
    Box,
    CardActionArea,
    Grid,
    Theme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import {
    Route,
    Switch,
    RouteComponentProps,
    withRouter,
} from 'react-router-dom';

import StoreModel from 'models/Index';
import { Services, RoutePaths } from 'helpers/constants';
import ApplicationFrame from './ApplicationFrame';

interface ApplicationSelectProps extends RouteComponentProps, WithTranslation {}
interface ApplicationSelectPropsInjected extends ApplicationSelectProps {
    Store: StoreModel;
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: '75vh',
        display: 'flex',
        margin: '0px 10% 0px 10%',
        justifyContent: 'center',
    },

    grid: {
        marginTop: 'auto',
        marginBottom: 'auto',
    },

    applicationCard: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none',
        backgroundColor: 'transparent',
    },

    applicationCardActionArea: {
        width: '300px',
        height: '300px',
        padding: theme.spacing(5),
    },

    applicationImage: {},
}));

const baseUrl = RoutePaths.ApplicationSelect;

const ApplicationSelect: FC<ApplicationSelectProps> = (props) => {
    const { Store } = props as ApplicationSelectPropsInjected;
    const { common } = Store;

    const classes = useStyles();

    const avaliableApps = common.applications;

    useEffect(() => {
        // if there is only one service, then navigate user to that service
        if (avaliableApps.length === 1) {
            return common.openApplication(avaliableApps[0]);
        }
    }, [common, avaliableApps]);

    return (
        <Switch>
            <Route
                exact
                path={baseUrl}
                render={() => (
                    <Box className={classes.root}>
                        <Grid container className={classes.grid}>
                            {avaliableApps.map((app) => (
                                <Grid
                                    key={app.id}
                                    item
                                    xs={avaliableApps.length >= 3 ? 4 : true}
                                >
                                    <Card className={classes.applicationCard}>
                                        <CardActionArea
                                            className={
                                                classes.applicationCardActionArea
                                            }
                                            onClick={() =>
                                                common.openApplication(app)
                                            }
                                        >
                                            <CardMedia
                                                component='img'
                                                alt={app.applicationName}
                                                title={app.applicationName}
                                                classes={{
                                                    root: classes.applicationImage,
                                                }}
                                                image={
                                                    `data:${app.logoMediaType};base64, ` +
                                                    app.logo
                                                }
                                            />
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
            />

            {avaliableApps.map((a, index) => {
                return (
                    <Route
                        key={index}
                        exact
                        path={a.path}
                        render={() => <ApplicationFrame app={a} />}
                    />
                );
            })}
        </Switch>
    );
};

export default withTranslation()(
    withRouter(inject(Services.STORE)(observer(ApplicationSelect)))
);
